/**
 * Build version and deploy date injected at image build time
 */
const MyPageBuildInfo = () => {
  const version = process.env.REACT_APP_WMS_VERSION;
  const deployedAt = process.env.REACT_APP_WMS_DEPLOYED_AT;
  if (!version && !deployedAt) return null;
  return (
    <div
      className="my-page-build-info"
      style={{
        padding: '12px 20px',
        fontSize: '12px',
        color: '#8c8c8c',
        textAlign: 'right',
      }}
    >
      {version && <span>WMS Version {version}</span>}
      {version && deployedAt && <span> · </span>}
      {deployedAt && <span>Deployed {deployedAt}</span>}
    </div>
  );
};

export default MyPageBuildInfo;
